import React, { useRef } from "react";
import { usePayment } from "./components/Checkout/context/PaymentContext";
import { Toast } from "primereact/toast";
import ConfirmDocument from "../../components/ConfirmDocument/ConfirmDocument";
import CartItems from "./components/CartItems/CartItems";
import ShippingCheckout from "./components/Shipping/ShippingCheckout";
import Checkout from "./components/Checkout/Checkout";
import ThankYouPage from "./components/ThankYouPage/ThankYouPage";
import ErrorCheckout from "./components/ErrorCheckout/ErrorCheckout";
import LandingFooter from "../Landing/components/LandingFooter/LandingFooter";
import LandingCopyright from "../Landing/components/LandingCopyright/LandingCopyright";

const ShoppingCartContent = ({
  order,
  orderItems,
  cashback,
  setOrder,
  setCashback,
  isLoadingOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setPrice,
  setOrderItems,
  walletExtracoinBalance,
  userPercentExtracoin,
  walletExtracoinBalanceForex,
  setOrderIsEmpty,
  orderIsEmpty,
  isLoadingWalletExtracoinBalanceForex,
  amountShipmentForexProduct,
  setAmountShipmentForexProduct,
  setAmountTransfer,
  amountTransfer,
  setLoading,
  amountWallet,
  currencyExchangeValue,
  amountToPayWithExtracredit,
  setAmountToPayWithExtracredit,
  amountBankTransfer,
  setAmountBankTransfer,
  bankTransferReceipt,
  setBankTransferReceipt,
  walletBalance,
  walletBalanceForex,
  price,
  currencyCode,
  setAmountWallet,
  userInfo,
  setUserInfo,
  setAddressInfo,
  setPriceForex,
  setDisplayPaymentModal,
  sendMethod,
  setSendMethod,
  isFringeBenefitsPage,
  idTransaction,
  showErrorToast,
}) => {
  const { page, setPage } = usePayment();
  const toast = useRef(null);

  return (
    <>
      {/*  <Navbar /> */}
      <Toast ref={toast} />

      <ConfirmDocument />

      <div
        className={`content-grid`}
        style={{
          backgroundColor: page === 4 ? "#f5f5f5" : "#FAFBFC",
          maxWidth: page === 4 ? "792px" : "100%",
          margin: "0 auto",
        }}
      >
        {page === 1 && (
          <CartItems
            walletBalance={walletBalance}
            order={order}
            cashback={isFringeBenefitsPage ? order?.cashback : cashback}
            setOrder={setOrder}
            setCashback={setCashback}
            isLoadingOrder={isLoadingOrder}
            currencyProduct={currencyProduct}
            currencyCodeUser={currencyCodeUser}
            currencyUser={currencyUser}
            page={page}
            setPrice={setPrice}
            orderItems={orderItems}
            setOrderItems={setOrderItems}
            walletExtracoinBalance={walletExtracoinBalance}
            userPercentExtracoin={userPercentExtracoin}
            walletExtracoinBalanceForex={walletExtracoinBalanceForex}
            setOrderIsEmpty={setOrderIsEmpty}
            orderIsEmpty={orderIsEmpty}
            isLoadingWalletExtracoinBalanceForex={isLoadingWalletExtracoinBalanceForex}
            userInfo={userInfo}
          />
        )}
        {page === 2 && (
          <ShippingCheckout
            cashback={isFringeBenefitsPage ? order.cashback : cashback}
            order={order}
            orderItems={orderItems}
            setOrder={setOrder}
            amountShipmentForexProduct={amountShipmentForexProduct}
            setAmountShipmentForexProduct={setAmountShipmentForexProduct}
            currencyProduct={currencyProduct}
            currencyCodeUser={currencyCodeUser}
            currencyUser={currencyUser}
            page={page}
            setAmountTransfer={setAmountTransfer}
            setLoading={setLoading}
            setPrice={setPrice}
            amountWallet={amountWallet}
            currencyExchangeValue={currencyExchangeValue}
            amountToPayWithExtracredit={amountToPayWithExtracredit}
            setAmountToPayWithExtracredit={setAmountToPayWithExtracredit}
            amountBankTransfer={amountBankTransfer}
            setAmountBankTransfer={setAmountBankTransfer}
            bankTransferReceipt={bankTransferReceipt}
            setBankTransferReceipt={setBankTransferReceipt}
            walletBalance={walletBalance}
            walletBalanceForex={walletBalanceForex}
            price={price}
            currencyCode={currencyCode}
            setAmountWallet={setAmountWallet}
            walletExtracoinBalance={walletExtracoinBalance}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            userPercentExtracoin={userPercentExtracoin}
            setAddressInfo={setAddressInfo}
            setPriceForex={setPriceForex}
            setDisplayPaymentModal={setDisplayPaymentModal}
            sendMethod={sendMethod}
            setSendMethod={setSendMethod}
            walletExtracoinBalanceForex={walletExtracoinBalanceForex}
          />
        )}
        {page === 3 && (
          <Checkout
            cashback={isFringeBenefitsPage ? order.cashback : cashback}
            order={order}
            orderItems={orderItems}
            setOrder={setOrder}
            amountShipmentForexProduct={amountShipmentForexProduct}
            setAmountShipmentForexProduct={setAmountShipmentForexProduct}
            currencyProduct={currencyProduct}
            currencyCodeUser={currencyCodeUser}
            currencyUser={currencyUser}
            page={page}
            setAmountTransfer={setAmountTransfer}
            setLoading={setLoading}
            setPrice={setPrice}
            amountWallet={amountWallet}
            currencyExchangeValue={currencyExchangeValue}
            amountToPayWithExtracredit={amountToPayWithExtracredit}
            setAmountToPayWithExtracredit={setAmountToPayWithExtracredit}
            amountBankTransfer={amountBankTransfer}
            setAmountBankTransfer={setAmountBankTransfer}
            bankTransferReceipt={bankTransferReceipt}
            setBankTransferReceipt={setBankTransferReceipt}
            walletBalance={walletBalance}
            walletBalanceForex={walletBalanceForex}
            price={price}
            currencyCode={currencyCode}
            setAmountWallet={setAmountWallet}
            walletExtracoinBalance={walletExtracoinBalance}
            userInfo={userInfo}
            userPercentExtracoin={userPercentExtracoin}
            setAddressInfo={setAddressInfo}
            setPriceForex={setPriceForex}
            setDisplayPaymentModal={setDisplayPaymentModal}
            sendMethod={sendMethod}
            setSendMethod={setSendMethod}
            walletExtracoinBalanceForex={walletExtracoinBalanceForex}
            setPage={setPage}
            showErrorToast={showErrorToast}
          />
        )}
        {page === 4 && (
          <ThankYouPage
            order={order}
            sendMethod={sendMethod}
            currencyCodeUser={currencyCodeUser}
            amountTransfer={amountTransfer}
          />
        )}
        {page === 5 && <ErrorCheckout order={order} idTransaction={idTransaction} />}
      </div>
      {/* <Footer /> */}
      <div className="content-grid bg-white">
        <LandingFooter />
        <LandingCopyright />
        <section
          className="md:py-5 full-width"
          style={{
            backgroundColor: "#FFFFFF",
            color: "#7A869A",
            borderTop: "1px solid #E0E7FF",
          }}
        >
          <div className="grid gap-3 m-0">
            <div className="col-12 md:col text-center md:text-left">
              <div className="text-sm font-regular">EXTRACONOMY GLOBAL srl</div>
            </div>
            <div className="col-12 md:col text-center md:text-left">
              <div className="text-sm font-regular">Via Nomentana, 1018 - 00137 Roma (IT)</div>
            </div>
            <div className="col-12 md:col text-center md:text-right">
              <div className="text-sm font-regular">P. Iva e C.F. 16948681008 | REA 1686351</div>
            </div>
            <div className="col-12 md:col text-center md:text-right">
              <div className="text-sm font-regular">Privacy Policy</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ShoppingCartContent;

